import { user, event } from '@/api'

import {
	USER_LOADING_STATUS,
	USER_POPULAR_GET,
	USER_POPULAR_GET_ERROR,
	USER_GET,
	USER_GET_ERROR,
	USER_FOLLOW,
	USER_FOLLOW_STATUS,
	USER_FOLLOW_ERROR,
	USER_UNFOLLOW_STATUS,
	USER_UNFOLLOW,
	USER_UNFOLLOW_ERROR,
	USER_GET_FOLLOWERS,
	USER_GET_FOLLOWERS_STATUS,
	USER_GET_FOLLOWERS_ERROR,
	USER_GET_FOLLOWINGS_STATUS,
	USER_GET_FOLLOWINGS,
	USER_UNFOLLOW_FROM_LIST_STATUS,
	USER_UNFOLLOW_FROM_LIST,
	USER_UNFOLLOW_FROM_LIST_ERROR,
	USER_SHOW_SUCCESS_ALERT,
	USER_SHOW_ERROR_ALERT,
	SPEAKER_GET,
	SPEAKER_SESSIONS_GET,
	SESSION_META_GET,
	SET_SPEAKER_SESSION_LOADING_ID,
	TOGGLE_IS_SPEAKER_SESSION_LOADING,
	UPDATE_SPEAKER_SESSION
} from './types'

const fetchPopularAuthors = async (ctx, query) => {
	ctx.commit(USER_LOADING_STATUS, true)
	try {
		const { data } = await user.fetchPopularAuthors(query)
		ctx.commit(USER_LOADING_STATUS, false)
		ctx.commit(USER_POPULAR_GET, data)
	} catch (e) {
		ctx.commit(USER_POPULAR_GET_ERROR, e)
		throw e
	}
}

const getAuthor = async (ctx, id) => {
	ctx.commit(USER_LOADING_STATUS, true)
	try {
		const { data } = await user.getAuthor(id)
		ctx.commit(USER_LOADING_STATUS, false)
		ctx.commit(USER_GET, data.data)
	} catch (e) {
		ctx.commit(USER_GET_ERROR, e)
		throw e
	}
}

const getSpeaker = async (ctx, id) => {
	ctx.commit(USER_LOADING_STATUS, true)
	try {
		const { data: speaker } = await user.getSpeaker(id)

		ctx.commit(SPEAKER_GET, speaker)
	} catch (e) {
		ctx.commit(USER_GET_ERROR, e)
		throw e
	} finally {
		ctx.commit(USER_LOADING_STATUS, false)
	}
}

const getSpeakerSessions = async (ctx, {id, type, page}) => {
	ctx.commit(USER_LOADING_STATUS, true)
	try {
		if (type === 'past' || !type) {
			const { data: speakerSessionsPast, headers } = await user.getSpeakerSessions(id, 'past', page || 1)
			ctx.commit(SPEAKER_SESSIONS_GET, { past: speakerSessionsPast })
			const pageCount = headers['x-pagination-page-count']
			const perPage = headers['x-pagination-per-page']
			const totalCount = headers['x-pagination-total-count']
			const currentPage = headers['x-pagination-current-page']
			const response = {
				pageCount,
				perPage,
				totalCount,
				currentPage,
				type: 'past'
			}
			ctx.commit(SESSION_META_GET, response)
		}
		if (type === 'future' || !type) {
			const { data: speakerSessionsFuture, headers } = await user.getSpeakerSessions(id, 'future', page || 1)
			ctx.commit(SPEAKER_SESSIONS_GET, { future: speakerSessionsFuture })
			const pageCount = headers['x-pagination-page-count']
			const perPage = headers['x-pagination-per-page']
			const totalCount = headers['x-pagination-total-count']
			const currentPage = headers['x-pagination-current-page']
			const response = {
				pageCount,
				perPage,
				totalCount,
				currentPage,
				type: 'future'
			}
			ctx.commit(SESSION_META_GET, response)
		}
	} catch (e) {
		ctx.commit(USER_GET_ERROR, e)
		throw e
	} finally {
		ctx.commit(USER_LOADING_STATUS, false)
	}
}

const getFollowers = async (ctx, id) => {
	ctx.commit(USER_GET_FOLLOWERS_STATUS, true)
	try {
		const { data } = await user.getFollowers(id)
		ctx.commit(USER_GET_FOLLOWERS_STATUS, false)
		ctx.commit(USER_GET_FOLLOWERS, data)
	} catch (e) {
		ctx.commit(USER_GET_FOLLOWERS_ERROR, e)
		throw e
	}
}

const getFollowings = async (ctx, id) => {
	ctx.commit(USER_GET_FOLLOWINGS_STATUS, true)
	try {
		const { data } = await user.getFollowings(id)
		ctx.commit(USER_GET_FOLLOWINGS_STATUS, false)
		ctx.commit(USER_GET_FOLLOWINGS, data)
	} catch (e) {
		ctx.commit(USER_GET_FOLLOWERS_ERROR, e)
		throw e
	}
}

const followUser = async (ctx, { following, follower }) => {
	ctx.commit(USER_FOLLOW_STATUS, true)
	try {
		await user.followUser(following)
		ctx.commit(USER_FOLLOW, follower)
		ctx.commit(USER_FOLLOW_STATUS, false)
	} catch (e) {
		ctx.commit(USER_FOLLOW_ERROR, e)
		throw e
	}
}

const unfollowUser = async (ctx, { following, follower }) => {
	ctx.commit(USER_UNFOLLOW_STATUS, true)
	try {
		await user.unfollowUser(following)
		ctx.commit(USER_UNFOLLOW_STATUS, false)
		ctx.commit(USER_UNFOLLOW, follower)
	} catch (e) {
		ctx.commit(USER_UNFOLLOW_ERROR, e)
		throw e
	}
}

const unfollowUserFromList = async (ctx, following) => {
	ctx.commit(USER_UNFOLLOW_FROM_LIST_STATUS, true)
	try {
		await user.unfollowUser(following.id)
		ctx.commit(USER_UNFOLLOW_FROM_LIST_STATUS, false)
		ctx.commit(USER_UNFOLLOW_FROM_LIST, following)
	} catch (e) {
		ctx.commit(USER_UNFOLLOW_FROM_LIST_ERROR, e)
		throw e
	}
}

const scheduleSession = async (ctx, {id, type}) => {
	try {
		ctx.commit(TOGGLE_IS_SPEAKER_SESSION_LOADING, true)
		ctx.commit(SET_SPEAKER_SESSION_LOADING_ID, id)
		await event.addMyAgenda({ agenda_id: id })
		ctx.commit(UPDATE_SPEAKER_SESSION, { id, type, status: 1 })
	} catch (e) { 
		console.log(e)
	} finally {
		ctx.commit(TOGGLE_IS_SPEAKER_SESSION_LOADING, false)
		ctx.commit(SET_SPEAKER_SESSION_LOADING_ID, null)
	}
}

const unscheduleSession = async (ctx, {id, type}) => {
	try {
		ctx.commit(TOGGLE_IS_SPEAKER_SESSION_LOADING, true)
		ctx.commit(SET_SPEAKER_SESSION_LOADING_ID, id)
		await event.removeMyAgenda(id)
		ctx.commit(UPDATE_SPEAKER_SESSION, { id, type, status: 0 })
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(TOGGLE_IS_SPEAKER_SESSION_LOADING, false)
		ctx.commit(SET_SPEAKER_SESSION_LOADING_ID, null)
	}
}

const showSuccessAlert = async (ctx) => {
	ctx.commit(USER_SHOW_SUCCESS_ALERT)
}
const showErrorAlert = async (ctx) => {
	ctx.commit(USER_SHOW_ERROR_ALERT)
}

export default {
	fetchPopularAuthors,
	getAuthor,
	followUser,
	unfollowUser,
	getFollowers,
	getFollowings,
	unfollowUserFromList,
	showSuccessAlert,
	showErrorAlert,
	getSpeaker,
	getSpeakerSessions,
	scheduleSession,
	unscheduleSession
}
